import React from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import Rule from './pages/rule';
import ZhuoZhuo from './pages/zhuozhuo';
import Rank from './pages/rank';
import Calc from './pages/calc';
import Eleven from './pages/eleven';
import Goods from './pages/goods';
import Arrival from './pages/arrival';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* 根路由重定向到 /rank */}
        <Route path="/" element={<Navigate to="/rule" />} />

        {/* 配置 /rule 路由 */}
        <Route path="/rule" element={<Rule />} />

        {/* 配置 /zhuozhuo 路由 */}
        <Route path="/zhuozhuo" element={<ZhuoZhuo />} />

        {/* 配置 /rank 路由 */}
        <Route path="/rank" element={<Rank />} />

        {/* 配置 /calc 路由 */}
        <Route path="/calc" element={<Calc />} />

        {/* 配置 /eleven 路由 */}
        <Route path="/eleven" element={<Eleven />} />

        {/* 配置 /goods 路由 */}
        <Route path="/goods" element={<Goods />} />

        {/* 配置 /arrival 路由 */}
        <Route path="/arrival" element={<Arrival />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
